import React from 'react';
import useToggle from '../../Hooks/useToggle';
import BackToTop from '../BackToTop';
import HeaderAbout from '../AboutUs/HeaderAbout';
import FooterHomeOne from '../HomeOne/FooterHomeOne';
import Drawer from '../Mobile/Drawer';
import DownloadPupilApp from './DownloadPupilApp';
import FeaturesPupilApp from './FeaturesPupilApp';
import HeroPupilApp from './HeroPupilApp';
import StepsPupilApp from './StepsPupilApp';

// Landing page for pupils: the pupil app invite links here
function PupilApp() {
    const [drawer, drawerAction] = useToggle(false);

    return (
        <>
            <Drawer drawer={drawer} action={drawerAction.toggle} />
            <HeaderAbout drawer={drawer} action={drawerAction.toggle} />
            <HeroPupilApp />
            <StepsPupilApp />
            <FeaturesPupilApp />
            <DownloadPupilApp />
            <FooterHomeOne />
            <BackToTop />
        </>
    );
}

export default PupilApp;
